import { render, staticRenderFns } from "./DiseaseScience.vue?vue&type=template&id=67508d0f&scoped=true&"
import script from "./DiseaseScience.vue?vue&type=script&lang=js&"
export * from "./DiseaseScience.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseScience.vue?vue&type=style&index=0&id=67508d0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67508d0f",
  null
  
)

export default component.exports